module.exports = __webpack_public_path__ + "img/gnkj-jianshe.e0d4c561.jpg";